import { isDevMode, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('@siza-staff-care/web-app/login').then((module) => module.LoginModule),
	},
	{
		path: '',
		// Lazily loaded app-container module. The main routing is set up in this module.
		loadChildren: () =>
			import('@siza-staff-care/web-app/app-container').then((module) => module.AppContainerModule),
		canActivate: [AuthGuard],
	},
	{
		path: '*',
		redirectTo: '',
	},
];

@NgModule({
	imports: [
		// Configure the router to pre-load all lazily-loaded
		// modules.
		QuicklinkModule,
		RouterModule.forRoot(routes, {
			// enableTracing: true, // <-- debugging purposes only

			// https://github.com/mgechev/ngx-quicklink
			preloadingStrategy: isDevMode() ? QuicklinkStrategy : PreloadAllModules,
		}),
	],
	exports: [RouterModule],
})
export class WebAppShellRoutingModule {}
